import { render } from "./TabIcon.vue?vue&type=template&id=36570bc2&scoped=true&ts=true"
import script from "./TabIcon.vue?vue&type=script&lang=ts"
export * from "./TabIcon.vue?vue&type=script&lang=ts"

import "./TabIcon.vue?vue&type=style&index=0&id=36570bc2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36570bc2"]])

export default __exports__